<template>
    <tr class="session__list_table_item">
        <td class="session__list_table_dates">{{ sessionDate }}</td>
        <td class="session__list_table_locations">
            <ul>
                <template v-if="sessionSessionType === 'virtual'">
                    <li>{{ sessionPlatform || toCapitalize }}</li>
                </template>
                <template v-else>
                    <li
                        :key="index"
                        v-for="(room, index) in sessionRooms"
                    >{{ room.venueName }} - {{ room.name }}</li>
                </template>
            </ul>
        </td>
        <td class="session__list_table_trainers">
            <ul>
                <li
                    :class="trainer.isActive === false ? 'session__list_table_trainers_trainer--error' : ''"
                    :key="index"
                    v-for="(trainer, index) in sessionTrainers"
                >{{ trainer.name }}{{ trainer.isActive === false ? ` (Inactive)` : '' }}</li>
            </ul>
        </td>
        <td class="session__list_table_spaces">{{ sessionSpaces }}</td>
        <td class="session__list_table_status">
            <div class="columns is-variable">
                <template v-if="allowDisplaySessionStatus">
                    <div class="column is-narrow">
                        <component-status :status="sessionStatus"/>
                    </div>
                </template>
                <template v-else>
                    <div class="column is-narrow">
                        <component-status :status="sessionUserBookingStatus"/>
                    </div>
                </template>
                <template v-if="allowDisplayUserBookingStatus">
                    <div class="column is-narrow">
                        <component-status :status="sessionUserBookingStatus"/>
                    </div>
                </template>
                <div class="column"></div>
            </div>
        </td>
        <td class="session__list_table_actions">
            <div class="columns is-inline-block is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :theme="'default'"
                        :to="{ name: 'ebs-session-show', params: { eventId: eventId, sessionId: sessionId } }"
                        :name="`session-list-table-actions-view-${sessionId}`"
                    >{{ $t('ebs.sessions.list.buttons.view') }}
                    </component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { User } from '@/User'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { maxNumber } from '@/variables'

export default {
  components: { ComponentButton, ComponentStatus },
  name: 'session-list-table-item',
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData),
      maxNumber
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    eventId: function () {
      return this.$route.params.id
    },
    sessionDate: function () {
      return this.item.nameDate
    },
    sessionId: function () {
      return this.item.id
    },
    sessionSessionType: function () {
      const rawSessionType = this.item.sessionType || 'face_to_face'
      return rawSessionType.replaceAll('_', '-')
    },
    sessionPlatform () {
      return this.item.occurrenceItems[0].platform + ' meeting'
    },
    sessionSpaces: function () {
      if (this.item.spaces.available === 0) {
        return this.$t('ebs.sessions.list.return.noSpacesAvailable')
      } else if (this.item.spaces.limit === maxNumber) {
        return `${this.item.spaces.limit - this.item.spaces.available} booked`
      } else {
        return `${this.item.spaces.available} / ${this.item.spaces.limit}` + (this.item.spaces.available !== 1 ? this.$t('ebs.sessions.list.return.spaces') : this.$t('ebs.sessions.list.return.space')) + this.$t('ebs.sessions.list.return.available')
      }
    },
    sessionStatus: function () {
      return this.item.status
    },
    sessionUserBookingStatus: function () {
      return this.item.userBookingStatus
    },
    sessionTrainers: function () {
      return this.sortByKey(this.item.trainers, 'name')
    },
    sessionRooms: function () {
      return this.sortByKey(this.item.rooms, 'venueName')
    },
    allowDisplayUserBookingStatus () {
      return (
        this.user.isEventCoordinator() ||
        this.user.isInfrastructureManager()
      ) &&
      this.sessionStatus !== 'ended'
    },
    allowDisplaySessionStatus () {
      return (
        this.user.isEventCoordinator() ||
        this.user.isInfrastructureManager()
      )
    }
  }
}
</script>
